import Vue from 'vue'
import Hammer from 'hammerjs'
// import Hammer from './hammer'

function HammerTouch (el, binding) {
  this.el = el
  this.type = binding.name
  this.binding = binding
  var hammertime = new Hammer(this.el, { inputClass: Hammer.TouchMouseInput })
  hammertime.on(this.type, this.binding.value)
  return hammertime
}

let hammerTouch = (el, binding) => new HammerTouch(el, binding)
const tap = Vue.directive('tap', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const swipe = Vue.directive('swipe', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const swiperight = Vue.directive('swiperight', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const swipeleft = Vue.directive('swipeleft', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const swipeup = Vue.directive('swipeup', {
  bind: function (el, binding) {
    // hammerTouch(el, binding)
    const hammertime = hammerTouch(el, binding)
    window.hammertime = hammertime
    hammertime.get('swipe').set({
      direction: Hammer.DIRECTION_UP, threshold: 10 // 解锁纵向滑动事件
    })
  }
})

const press = Vue.directive('press', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const pressup = Vue.directive('pressup', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const pan = Vue.directive('pan', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const panstart = Vue.directive('panstart', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const panmove = Vue.directive('panmove', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

const panend = Vue.directive('panend', {
  bind: function (el, binding) {
    hammerTouch(el, binding)
  }
})

export {
  tap,
  swipe,
  swipeup,
  swiperight,
  swipeleft,
  press,
  pressup,
  pan,
  panstart,
  panmove,
  panend
}



// WEBPACK FOOTER //
// ./src/directives/touch.js